export default window.bootstrapvalidation = function bootstrapvalidation() {

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.getElementsByClassName('needs-validation');
    // Loop over them and prevent submission
    var validation = Array.prototype.filter.call(forms, function(form) {
    form.addEventListener('submit', function(event) {
        const inputElement = document.getElementById('ricercainput');
        let ricercaisvalid = 1;
        if (ricercainput) {
            const value = inputElement.value.trim();
            console.log(value.length + ' caratteri')
            if (value.length < 3) {
                ricercaisvalid = 0;
            } else {
                ricercaisvalid = 1;
                ricercainput.setCustomValidity("");
            }
        }
        if (form.checkValidity() === false || ricercaisvalid === 0) {
            event.preventDefault();
            event.stopPropagation();
            if (ricercaisvalid === 0) {
                ricercainput.setCustomValidity("Invalid field.");
            }
        }
        form.classList.add('was-validated');
    }, false);
    });
};

(function() {
    'use strict';
    window.addEventListener('load', function() {
        bootstrapvalidation();
    }, false);
})();
